/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportUrl } from '../../models/report-url';
import { ReportUrlDto } from '../../models/report-url-dto';

export interface CreateReportUrl$Params {
  body: ReportUrlDto;
}

export function createReportUrl(
  http: HttpClient,
  rootUrl: string,
  params: CreateReportUrl$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ReportUrl>> {
  const rb = new RequestBuilder(rootUrl, createReportUrl.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportUrl>;
    })
  );
}

createReportUrl.PATH = '/admin/reporting/report-url';
